import { Component } from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {TransactionsService} from '../../../shared/services/transactions.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent {
  loader = false;
  searchForm: FormGroup;
  displayedColumns: string[] = ['id', 'monto', 'usuario', 'estado', 'clave', 'fecha', 'msi', 'tipo', 'firma'];
  dataSource: any;
  checked = false;

  constructor(private router: Router, private service: TransactionsService, private fb: FormBuilder) {
    this.searchForm = this.fb.group({
      idusuario: [''],
      id: [''],
      terminacion: [''],
      sinfirma: ['']
    });
  }

  async getTransactions(): Promise<void> {
    this.loader = true;
    try {
      const response = await this.service.getTransactions(this.searchForm.value);
      if (response) {
        this.dataSource = response.message;
      }
    } catch (e) {
      await Swal.fire({
        icon: 'error',
        text: e.message
      });
      console.log(e);
    } finally {
      this.loader = false;
    }
  }

  async detail(element: any): Promise<any> {
    await this.router.navigate([`/transacciones/detalles/${element}`]);
    console.log(element);
  }
}
